import { render, staticRenderFns } from "./section2m.vue?vue&type=template&id=92349e0a&scoped=true"
import script from "./section2m.vue?vue&type=script&lang=js"
export * from "./section2m.vue?vue&type=script&lang=js"
import style0 from "./section2m.vue?vue&type=style&index=0&id=92349e0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92349e0a",
  null
  
)

export default component.exports